import {
  Directive,
  EventEmitter,
  HostListener,
  Output
} from '@angular/core';
export class DragAndDropDirective {
private fileDropEmitter: EventEmitter<FileList> = new EventEmitter();
/**
 * @param {?} e
 * @return {?}
 */
onDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    const /** @type {?} */ files = e.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropEmitter.emit(files);
    }
  }
/**
 * @param {?} e
 * @return {?}
 */
onDragOver(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[DragAndDrop]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fileDropEmitter': [{ type: Output },],
'onDrop': [{ type: HostListener, args: ['drop', ['$event'], ] },],
'onDragOver': [{ type: HostListener, args: ['dragover', ['$event'], ] },],
};
}

function DragAndDropDirective_tsickle_Closure_declarations() {
/** @type {?} */
DragAndDropDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DragAndDropDirective.ctorParameters;
/** @type {?} */
DragAndDropDirective.propDecorators;
/** @type {?} */
DragAndDropDirective.prototype.fileDropEmitter;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
